<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>角色列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="success"
							   size="small"
							   icon="el-icon-check"
							   @click="saveClick('roleMenu')">保存
					</el-button>
				</div>
			</div>
			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="roleContent"
						 style="overflow-y: auto; border:1px solid #eee">
						<el-tree ref="roleTree"
								 :height="roleTreeData.tableH"
								 :data="roleTreeData.tableData"
								 :props="defaultProps"
								 :expand-on-click-node="false"
								 :highlight-current="true"
								 default-expand-all
								 show-checkbox
								 node-key="id"
								 :default-checked-keys="treeDefaultCheckedKey"
								 @node-click="nodeClick"
								 @check="treeCheck"></el-tree>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { roleInsert } from 'api/system/roleLimit.js'

export default {
	props: {
		list: {
			type: Array,
			default: () => {
				return []
			}
		},

		value: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	data() {
		return {
			roleId: '',
			treeDefaultCheckedKey: [],
			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '650px',
				mode: 'add'
			},
			roleTreeData: {
				loading: false,
				tableH: 200,
				tableData: [],
				tableOriData: [],
				tableByRoleData: []
			},
			defaultProps: {
				children: 'children',
				label: 'sname'
			}
		}
	},
	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	methods: {
		treeCheck(data, node) {
			this.$emit('input', node.checkedKeys)
		},

		saveClick() {
			this.$emit('save')
		},

		nodeClick(obj) {
			this.$emit('row-click', obj.id)
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.roleTreeData.tableH = this.$refs.roleContent.offsetHeight
			}, 100)
		})
	},
	created() {
		this.roleTreeData.tableData = this.list
	},
	watch: {
		clientSize(val) {
			this.roleTreeData.tableH = this.$refs.roleContent.offsetHeight
		},

		list(val) {
            this.roleTreeData.tableData = val
        },

		value(val) {
			this.$refs.roleTree.setCheckedKeys(val)
		}
	}
}
</script>

<style lang="less" scoped>
.tree-content {
	overflow-y: auto;
	padding: 5px 0px;
}

.w-table-page {
	padding-bottom: 5px;
}
</style>
